// src/components/templates/BusinessSegments.tsx

import { Container } from '@mui/material'
import Grid from '@mui/material/Grid2'
import AtomButton from '../../atoms/button/button'
import { ChevronRight, CirclePatternTop } from '../../helpers/constant/imageUrl'
import { useNavigate } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { fetchCategories } from '../../redux/slice/categoriesSlice'
import { AppDispatch } from '../../redux/storage/store'

const BusinessSegments = () => {
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const { items: categories, loading } = useSelector((state: any) => state.categories)

    useEffect(() => {
        dispatch(fetchCategories())
    }, [dispatch])

    return (
       
        <>
        <Container className='container'>
                <h1>Business Segments</h1>
                <p>
                    In a dynamic market environment characterized by rapid shifts in consumer behavior and evolving demands,
                    KOPL serves customers across diverse industries and regions, confronting a spectrum of challenges.
                </p>
                {loading ? (
                    <p>Loading categories...</p>
                ) : (
                    <Grid container spacing={3}>
                        {categories?.map((category: any) => (
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={category.id}>
                                <div className="product-thumb">
                                    <img src={category.image} alt={category.name} />
                                    <div className="overlay">
                                        {category.name}
                                        <AtomButton
                                            onClick={() =>
                                                navigate(`/products/${category?.name?.toString().replace(/ /g, '-')}`, {                                                    
                                                    state: { categoryName: category.name }
                                                })
                                            }
                                        >
                                            VIEW MORE
                                            <img src={ChevronRight} alt='chevron' />
                                        </AtomButton>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Container>
        </>
            
    )
}

export default BusinessSegments
